<div nxLayout="grid maxwidth" class="edit-insured-trip">
    <div nxRow>
        <div nxCol="12">
            <nx-card>
                <nx-card-header>
                    <h3 nxHeadline="subsection-medium" translate class="title">policy.insured-trips.edit.title</h3>
                </nx-card-header>
                <div class="trip-content">
                    <div nxRow>
                        <div nxCol="12">
                            <form [formGroup]="formEditInsuredTrip" (submit)="updateTrip($event)" *ngIf="obsForm|async">
                                <div nxRow>
                                    <div nxCol="8">
                                        <div nxRow>
                                            <div nxCol="12" class="item-info">
                                                <div nxRow>
                                                    <div nxCol="12">
                                                        <span class="nx-font-weight-light">{{
                              'policy.insured-trips.data.it-number' | translate
                              }}
                                                            <span class="nx-font-weight-semibold">{{
                                insuredTripDetail.policyNumber }}</span></span>
                                                    </div>
                                                </div>
                                                <div nxRow>
                                                    <div nxCol="12">
                                                        <span class="nx-font-weight-light">{{
                              'policy.insured-trips.it-status.title' | translate
                              }}
                                                            <span class="nx-font-weight-semibold">{{
                                insuredTripDetail.statusLabel }}</span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div nxRow>
                                            <div nxCol="12" class="item-info">
                                                <div nxRow>
                                                    <div nxCol="12">
                                                        <span class="nx-font-weight-light">{{
                              'policy.insured-trips.data.module' |
                              translate }}
                                                            <span class="nx-font-weight-semibold">{{
                                this.moduleNameByTarrif(insuredTripDetail.tariff) }}</span></span>
                                                    </div>
                                                </div>
                                                <div nxRow>
                                                    <div nxCol="12">
                                                        <span class="nx-font-weight-light">{{
                              'policy.insured-trips.data.country-zone' |
                              translate }}
                                                            <span class="nx-font-weight-semibold">{{
                                insuredTripDetail.zone }}</span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div nxRow>
                                            <div nxCol="12" class="item-info">
                                                <div nxRow>
                                                    <div nxCol="12">
                                                        <span class="nx-font-weight-light">{{
                              'policy.insured-trips.data.tariff' |
                              translate }}
                                                            <span class="nx-font-weight-semibold">{{
                                insuredTripDetail.tariff }}</span></span>
                                                    </div>
                                                </div>
                                                <div nxRow>
                                                    <div nxCol="12">
                                                        <span class="nx-font-weight-light">{{
                              'policy.insured-trips.data.charge' |
                              translate }}
                                                            <span class="nx-font-weight-semibold">{{
                                insuredTripDetail.rate | currencyFormat }}</span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div nxRow>
                                            <div nxCol="12,8">
                                                <nx-formfield
                                                    label="{{ 'policy.insured-trips.data.start-insurance-date' | translate }}">
                                                    <input nxDatefield nxInput [datepicker]="dateDatepickerStart" (dateChange)="changedDateStart($event)"
                                                        [datefieldFilter]="filterDateBegin" formControlName="dateBegin"
                                                        [parseFormat]="['DD.MM.YYYY', 'D.M.YYYY']"
                                                        displayFormat="DD.MM.YYYY" />
                                                    <nx-datepicker-toggle [for]="dateDatepickerStart" nxFormfieldSuffix>
                                                    </nx-datepicker-toggle>
                                                    <nx-datepicker #dateDatepickerStart></nx-datepicker>
                                                </nx-formfield>
                                            </div>
                                        </div>

                                        <div nxRow>
                                            <div nxCol="12,8">
                                                <nx-formfield
                                                    label="{{ 'policy.insured-trips.data.end-insurance-date' | translate }}">
                                                    <input nxDatefield nxInput [datepicker]="dateDatepickerEnd"
                                                        [datefieldFilter]="filterDateEnd" formControlName="dateEnd"
                                                        [parseFormat]="['DD.MM.YYYY', 'D.M.YYYY']"
                                                        displayFormat="DD.MM.YYYY" />
                                                    <nx-datepicker-toggle [for]="dateDatepickerEnd" nxFormfieldSuffix>
                                                    </nx-datepicker-toggle>
                                                    <nx-datepicker #dateDatepickerEnd [startAt]="dateEndStart"></nx-datepicker>
                                                </nx-formfield>
                                            </div>
                                        </div>


                                        <div nxRow>
                                            <div nxCol="12" class="form-partner">
                                                <nx-formfield label="{{ 'policy.employees.data.name' | translate }}">
                                                    <input nxInput type="text" formControlName="partner" />
                                                </nx-formfield>
                                            </div>
                                        </div>
                                        
                                        <div nxRow *ngIf="canBeCanceled">
                                            <div nxCol="12" class="form-partner">
                                                <nx-formfield
                                                    label="{{ 'policy.insured-trips.data.change-employee' | translate }}">
                                                    <input nxInput type="text" nxAutocompleteDebounce='0'
                                                        [nxAutocomplete]='employeesAutocomplete' #employeesInput />
                                                </nx-formfield>
                                                <nx-autocomplete #employeesAutocomplete='nxAutocomplete'
                                                    (optionSelected)="selectEmployee($event)">
                                                    <nx-autocomplete-option
                                                        *ngFor='let item of getEmployees(employeesInput.value)'
                                                        [value]='item | employeeFormat'>
                                                        {{item | employeeFormat }}
                                                    </nx-autocomplete-option>
                                                </nx-autocomplete>
                                                <div nxRow>
                                                    <div nxCol="12" class="employee"
                                                        [ngClass]="changedEmployee.value ? '' : 'hidden'">
                                                        <cpc-icon icon='trash-o' color="#007ab3" style="font-size: 20px"
                                                            (click)="deselectEmployee()"></cpc-icon>
                                                        <nx-formfield
                                                            label="{{ 'policy.insured-trips.data.employee' | translate }}">
                                                            <input nxInput type="text" nxDisabled #changedEmployee
                                                                formControlName="changedEmployee" />
                                                        </nx-formfield>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div nxRow>
                                            <div nxCol="12" class="insurance-price">
                                                <span class="nx-font-weight-light">{{
                                                        'policy.insured-trips.data.premium' |
                                                        translate }}
                                                    <span class="nx-font-weight-semibold">{{
                                                            insuredTripDetail.premium | currencyFormat
                                                        }}</span></span>
                                            </div>
                                        </div>

                                        <div nxRow class="nx-margin-top-m" *ngIf="this.showHasTravel">
                                            <div nxCol="12">
                                                <h3 nxHeadline="subsection-medium" translate class="title">
                                                    policy.insured-trips.employee-has-travel</h3>
                                                <p *ngFor="let item of this.hasTravel.list">
                                                    <nx-link>
                                                        <a
                                                            href="{{ getHasTravelLink(item.policyNumber) }}">{{item.policyNumber}}</a>
                                                    </nx-link> - {{ item.dateBegin|dateFormat }}
                                                    {{ item.dateEnd|dateFormat }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div nxCol="4">
                                        <button *ngIf="insuredTripDetail.statusId === 4" nxButton="primary normal"
                                            (click)="generateTravelCard()" type="button">
                                            <span translate>policy.insured-trips.edit.print-travel-card</span>
                                        </button>
                                    </div>
                                </div>

                                <div nxRow>
                                    <div nxCol="12" class="form-buttons">
                                        <a routerLink="../">
                                            <button nxButton="secondary normal" type="button">
                                                <span translate>policy.insured-trips.back-btn</span>
                                            </button>
                                        </a>
                                        <div class="form-buttons__submit" *ngIf="canBeEdited || canBeEditedDateEnd ">
                                            <button nxButton="primary normal" (click)="cancelTrip()" type="button"
                                                *ngIf="canBeCanceled">
                                                <span translate>policy.insured-trips.edit.submit-cancel-btn</span>
                                            </button>
                                            <button nxButton="primary normal" (click)="changeEndDate()" type="button"
                                                *ngIf="this.formEditInsuredTrip.touched && canBeEditedDateEnd">
                                                <span translate>policy.insured-trips.edit.submit-change-date-btn</span>
                                            </button>
                                            <button nxButton="primary normal" type="submit"
                                                *ngIf="this.formEditInsuredTrip.touched && canBeEdited">
                                                <span translate>policy.insured-trips.edit.submit-btn</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </nx-card>
        </div>
    </div>
</div>